import { useCallback } from "react";
import { ISegment } from "src/helpers/segmentFilterHook";

import { Checkbox, TextBox } from "@repo/ui";

import { SegmentFilters } from "../../../components/segmentFilters";
import { useMapSettings } from "../hooks";
import { IMapFilter, useMapFilters } from "./filterContext";

export function LiveViewMapFilters() {
	const { filters, setFilters } = useMapFilters();
	const mapSettingsQuery = useMapSettings();

	const segmentChanged = useCallback(
		(segFilters: ISegment) => setFilters({ ...filters, ...segFilters }),
		[filters, setFilters],
	);

	const filterChanged = useCallback(
		(value: any, name: string & keyof IMapFilter) => setFilters({ ...filters, [name]: value }),
		[filters, setFilters],
	);

	return (
		<>
			<SegmentFilters onChange={segmentChanged} value={filters} />
			<Checkbox
				id="retailLocations"
				label={"Show Retail Locations"}
				value={filters.retailLocations}
				changeHandler={filterChanged}
				inline
				hidden={!mapSettingsQuery.data?.canShowRetailLocations}
			/>
			<TextBox
				label="Last Updated Within Hours"
				id="limitToLastHours"
				value={filters.limitToLastHours}
				changeHandler={filterChanged}
			/>
		</>
	);
}
